export const ROUTE_TO_CONNECT = "/connect";
export const CONNECT_BUTTON_NAME = "CONNECT US";
export const STYLES = ["btn--primary", "btn--outline", "btn--test"];
export const SIZES = ["btn--medium", "btn--large"];
